import { Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CommonService } from '../../../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiResponse } from '../../../../models/api-response.model';
import { Subject, combineLatest } from 'rxjs';
import { PostcodeList, SuburbList } from '../../../../models/account-delivery-address';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DOCUMENT } from '@angular/common';
import { distinctUntilChanged, finalize, takeUntil } from 'rxjs/operators';
import { IAMPCustomerDetailsViewModel, IAdobeCustomer } from '../../../../models/amp.model';
import { AdobeService } from '../../../../services/adobe.service';
import { ShoppingCartService } from '../../../../services/shopping-cart.service';
import { StateModel } from '../../../../models/account-ledger.model';
import { MatDialog } from '@angular/material/dialog';
import { SimpleMsgPopupComponent } from '../../../../popup-collection/simple-msg/simple-msg-popup.component';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-amp-customer-details-edit',
  templateUrl: './amp-customer-details-edit.component.html',
  styleUrls: ['./amp-customer-details-edit.component.css']
})
export class AMPCustomerDetailsEditComponent implements OnInit, OnDestroy {

  public userFormGroup: FormGroup;
  public extra3YCOption: string;
  public minDate;
  private resellerId: string;
  private original3YCMLC: string;
  programType: string = '';
  details: IAMPCustomerDetailsViewModel;
  setFullWindow: boolean = true;
  title: string = "Edit Customer Details";
  loadContent: boolean = false;
  filterInput: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  stateList: string[];
  user_validation_messages: any = {
    // "marketSegmentField": [
    //   { class: "marketSegmentValidate", message: "Please choose market segment/s" }
    // ],
    "emailField": [
      { class: "emailValidate", message: "Please enter email" }
    ],
    "phoneField": [
      { class: "phoneValidate", message: "Please enter phone" }
    ],
    "addressLine1Field": [
      { class: "addressLine1Validate", message: "Please enter address" }
    ],
    "suburbField": [
      { class: "suburbValidate", message: "Please enter suburb" }
    ],
    "stateField": [
      { class: "stateValidate", message: "Please choose state" }
    ],
    "postcodeField": [
      { class: "postcodeValidate", message: "Please enter postcode" }
    ],

  };

  get cotermControl() {
    return this.userFormGroup.get('userGroup.coterm') as FormControl
  }
  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  constructor(
    private adobeService: AdobeService,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private router: Router,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    public authService: AuthService,
    @Inject(DOCUMENT) private _document: Document) {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getUserGroup()
    });
    // const today = new Date()
    // this.minDate = new Date(today.getFullYear() + 1, today.getMonth() + 1, today.getDate());
    // this.userFormGroup.get('userGroup.coterm').setValue(this.minDate);
  }

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505 }, 400);
  }

  ngOnInit() {
    this.extra3YCOption = this.adobeService.extra3YCOption;
    this.shoppingCartService.getState().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: StateModel) => {
      this.stateList = res.states;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

    combineLatest([
      this.adobeService.currentAMPCustomerDetailsWatch,
      this.adobeService.getCurrentAMPSubscriptions
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        ([detail, subs]) => {
          if (detail) {
            this.details = detail;
            this.original3YCMLC = detail?.customer?.number_of_license_commitments
            this.populateFields();

            const disableSegment = subs?.filter(s => s.out_status_desc == 'Active')?.length > 0;
            if (disableSegment) this.userFormGroup.get('userGroup.marketSegmentField').disable();
          }
        },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        }
      );

    this.adobeService.getCurrentAMPResellerId.pipe(takeUntil(this.ngUnsubscribe)).subscribe(resellerId => {
      this.resellerId = resellerId;
    });

    this.userFormGroup.get('userGroup.commmitmentToggle').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((toggle) => {
        if (toggle && !this.details?.customer?.is_3y_commit && (this.isWithinYear(this.details?.customer?.coterm_date) || (this.details?.customer?.coterm_date == null ))) {
          this.dialog.open(SimpleMsgPopupComponent, {
            width: '400px',
            data: {
              showCancel: true,
              title: '3 Year Commit',
              msg: 'Customer will need to accept the 3YC invitation from their admin console and place a qualifying order within 7 days to qualify.',
              buttonName: 'Accept'
            }
          }).afterClosed().subscribe((res) => {
            if (!res) {
              this.userFormGroup.get("userGroup.commmitmentToggle").setValue(false)
            }
          });
        }
      })

  }

  /**
   * Checks if a given date is within 12 months from today's date.
   * @param date - The date to check (in milliseconds since the Unix epoch).
   * @returns `true` if the date is within the next 12 months, `false` otherwise.
   */
  isWithinYear(date: string): boolean {
    const cotermDate = new Date(date);
    const today = new Date();
    const twelveMonthsFromNow = new Date(today);
    twelveMonthsFromNow.setMonth(today.getMonth() + 12);

    return cotermDate >= today && cotermDate <= twelveMonthsFromNow;
  }

  toggle3yCommit(date: string): boolean {
    const isValidDate = this.isWithinYear(date);
    if( date == null){ // return true if there is no Anniversary Date
      return true;
    }
    if (!isValidDate) {
      this.commonService.implementToast('3YC can only be selected within 12 months of the Anniversary Date', 'Info')
      this.userFormGroup.get("userGroup.commmitmentToggle").setValue(false)
      return false;
    } else {
      return true
    }
  }

  getUserGroup(): FormGroup {
    return this.formBuilder.group({
      companyNameField: new FormControl({value: "",  disabled: true}, Validators.compose([Validators.required])),
      marketSegmentField: new FormControl({value: "",  disabled: true}, Validators.compose([Validators.required])),
      addressLine1Field: new FormControl("", Validators.compose([Validators.required])),
      addressLine2Field: new FormControl(""),
      addressLine3Field: new FormControl(""),
      stateField: new FormControl("", Validators.compose([Validators.required])),
      suburbField: new FormControl("", Validators.compose([Validators.required])),
      postcodeField: new FormControl("", Validators.compose([Validators.required])),
      firstNameField: new FormControl({value: "",  disabled: true}, Validators.compose([Validators.required])),
      lastNameField: new FormControl({value: "",  disabled: true}, Validators.compose([Validators.required])),
      emailField: new FormControl("", this.commonService.emailValidatorRegex()),
      phoneField: new FormControl("", Validators.compose([Validators.required])),
      // cotermToggle: new FormControl(false),
      // coterm: new FormControl(null),
      commmitmentToggle: new FormControl(false),
      noOfLicenseCommitments: new FormControl(""),
      noOfConsumablesCommitments: new FormControl("")
    });
  }

  populateFields() {
    this.userFormGroup.get("userGroup.companyNameField").setValue(this.details?.customer?.company_name);
    this.userFormGroup.get("userGroup.marketSegmentField").setValue(this.details?.customer?.market_segment);
    this.userFormGroup.get("userGroup.addressLine1Field").setValue(this.details?.customer?.address_1);
    this.userFormGroup.get("userGroup.addressLine2Field").setValue(this.details?.customer?.address_2);
    this.userFormGroup.get("userGroup.addressLine3Field").setValue(this.details?.customer?.address_3);
    this.userFormGroup.get("userGroup.stateField").setValue(this.details?.customer?.region);
    this.userFormGroup.get("userGroup.suburbField").setValue(this.details?.customer?.city);
    this.userFormGroup.get("userGroup.postcodeField").setValue(this.details?.customer?.post_code);
    this.userFormGroup.get("userGroup.firstNameField").setValue(this.details?.customer?.first_name);
    this.userFormGroup.get("userGroup.lastNameField").setValue(this.details?.customer?.last_name);
    this.userFormGroup.get("userGroup.emailField").setValue(this.details?.customer?.email);
    this.userFormGroup.get("userGroup.phoneField").setValue(this.details?.customer?.phone);
    // this.userFormGroup.get("userGroup.cotermToggle").setValue(this.details?.customer?.is_coterm);
    // this.userFormGroup.get("userGroup.coterm").setValue(this.details?.customer?.coterm_date);
    this.userFormGroup.get("userGroup.commmitmentToggle").setValue(this.details?.customer?.is_3y_commit);
    if (this.details?.customer?.is_3y_commit) this.userFormGroup.get("userGroup.commmitmentToggle").disable();
    this.userFormGroup.get("userGroup.noOfLicenseCommitments").setValue(this.details?.customer?.number_of_license_commitments);
    // this.userFormGroup.get("userGroup.noOfConsumablesCommitments").setValue(this.details?.customer?.number_of_consumables_commitments);

    if (this.adobeService.extra3YCOption) {
      this.userFormGroup.get("userGroup.commmitmentToggle").setValue(true);
      this.userFormGroup.get("userGroup.noOfLicenseCommitments").setValue(this.adobeService.extra3YCOption);
    }

    this.loadContent = true;
  }

  public getNoOfLicensePlaceHolder() {
    const today = this.commonService.getPDTDate();
    const endDate = new Date(this.details?.customer?.three_year_commitment_end_date);
    let daysDiff = Math.round((endDate.valueOf() - today.valueOf()) / (1000 * 60 * 60 * 24));

    return daysDiff < 30 ? 'Minimum License Re-Commitment' : 'Minimum License Commitment';
  }

  updateEndUser(): void {
    if (
      // this.userFormGroup.get('userGroup.marketSegmentField').valid &&
      this.userFormGroup.get('userGroup.emailField').valid &&
      this.userFormGroup.get('userGroup.addressLine1Field').valid &&
      this.userFormGroup.get('userGroup.suburbField').valid &&
      this.userFormGroup.get('userGroup.stateField').valid &&
      this.userFormGroup.get('userGroup.postcodeField').valid &&
      this.userFormGroup.get('userGroup.phoneField').valid
    ) {
      let flag = false;
      if (this.userFormGroup.get("userGroup.postcodeField").value.length < 4) {
        flag = true;
        this.commonService.showValidator('.postcodeValidate', "Please input valid postcode", "right", "error");
      }

      if (this.userFormGroup.get('userGroup.commmitmentToggle').value) {
        if (
          !this.userFormGroup.get('userGroup.noOfLicenseCommitments').value
          // && !this.userFormGroup.get('userGroup.noOfConsumablesCommitments').value
        ) {
          flag = true;
          this.commonService.showValidator('.noOfLicenseCommitmentsValidate', "Please enter number of license commitments or number of consumable commitments", "right", "error");
          // this.commonService.showValidator('.noOfConsumablesCommitmentsValidate', "Please enter number of license commitments or number of consumable commitments", "right", "error");
        }

        // if (parseInt(this.userFormGroup.get('userGroup.noOfConsumablesCommitments').value) < 1000) {
        //   flag = true;
        //   this.commonService.showValidator('.noOfConsumablesCommitmentsValidate', "Minimum of 1000 quantities for consumable commitments", "right", "error");
        // }

        if (parseInt(this.userFormGroup.get('userGroup.noOfLicenseCommitments').value) < parseInt(this.details.customer.number_of_license_commitments)) {
          flag = true;
          this.commonService.showValidator('.noOfLicenseCommitmentsValidate', "Commitment quantities can be increased but cannot be decreased during the 3 year commitment period.", "right", "error");
        }

        // if (parseInt(this.userFormGroup.get('userGroup.noOfConsumablesCommitments').value) < parseInt(this.details.customer.number_of_consumables_commitments)) {
        //   flag = true;
        //   this.commonService.showValidator('.noOfConsumablesCommitmentsValidate', "Commitment quantities can be increased but cannot be decreased during the 3 year commitment period.", "right", "error");
        // }
      }

      if (!flag) {
        let inputModel = {} as IAdobeCustomer
        console.log(this.userFormGroup.get('userGroup.noOfLicenseCommitments').value)
        console.log(this.original3YCMLC)
        console.log(this.userFormGroup.get('userGroup.noOfLicenseCommitments').value > this.original3YCMLC)
        const is_3y_commit = +this.userFormGroup.get('userGroup.noOfLicenseCommitments').value > +this.original3YCMLC;
        console.log(is_3y_commit)
        inputModel = {
          partner_id: this.resellerId,
          customer_id: this.details?.customer?.customer_id,
          company_name: this.userFormGroup.get('userGroup.companyNameField').value,
          market_segment: this.userFormGroup.get('userGroup.marketSegmentField').value,
          address_1: this.userFormGroup.get('userGroup.addressLine1Field').value,
          address_2: this.userFormGroup.get('userGroup.addressLine2Field').value,
          address_3: this.userFormGroup.get('userGroup.addressLine3Field').value,
          first_name: this.userFormGroup.get('userGroup.firstNameField').value,
          last_name: this.userFormGroup.get('userGroup.lastNameField').value,
          email: this.userFormGroup.get('userGroup.emailField').value,
          city: this.userFormGroup.get('userGroup.suburbField').value,
          region: this.userFormGroup.get('userGroup.stateField').value,
          post_code: this.userFormGroup.get('userGroup.postcodeField').value,
          phone: this.userFormGroup.get('userGroup.phoneField').value,
          is_coterm: this.details?.customer?.is_coterm,
          is_3y_commit,
          number_of_license_commitments: is_3y_commit ? this.userFormGroup.get('userGroup.noOfLicenseCommitments').value : null,
          number_of_consumables_commitments: is_3y_commit ? this.userFormGroup.get('userGroup.noOfConsumablesCommitments').value : null
        };
        if (inputModel.is_coterm) {
          // const cotermDate = new Date(this.userFormGroup.get('userGroup.coterm').value)
          // cotermDate.setDate(cotermDate.getDate() + 1);
          // inputModel.coterm_date = cotermDate.toISOString().split('T')[0]
          inputModel.coterm_date = this.details?.customer?.coterm_date
        }

        this.loadContent = false;
        this.adobeService.updateAMPTenant(inputModel)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (res: ApiResponse) => {
              if (res && res.status) {
                this.commonService.implementToast(res.responseMessage, "Success");
                this.adobeService.refetchAMPTenantDetailView$.next()
                this.close();
              } else {
                this.commonService.implementToast(res.responseMessage, "Error");
              }
            },
            (error: string) => {
              this.commonService.implementToast(error, "Error");
            },
            () => {
              this.loadContent = true;
            }
          );
      }
    } else {
      // this.isNotValidField("userGroup.marketSegmentField", this.user_validation_messages.marketSegmentField);
      this.isNotValidField("userGroup.emailField", this.user_validation_messages.emailField);
      this.isNotValidField("userGroup.addressLine1Field", this.user_validation_messages.addressLine1Field);
      this.isNotValidField("userGroup.suburbField", this.user_validation_messages.suburbField);
      this.isNotValidField("userGroup.stateField", this.user_validation_messages.stateField);
      this.isNotValidField("userGroup.postcodeField", this.user_validation_messages.postcodeField);
      this.isNotValidField("userGroup.phoneField", this.user_validation_messages.phoneField);
    }
  }

  validateFields(item: any) {
    if (item.field === "out_email") {
      if (this.userFormGroup.get(item.field).hasError("required")) {
        this.commonService.showValidator("." + item.class, item.message, "right", "error");
      } else if (this.userFormGroup.get(item.field).hasError("email")) {
        this.commonService.showValidator("." + item.class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(item.field).valid) {
        this.commonService.showValidator("." + item.class, item.message, "right", "error");
      }
    }
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('userGroup.postcodeField').setValue(option.postcode);
    this.userFormGroup.get('userGroup.stateField').setValue(option.state);
    this.userFormGroup.get('userGroup.suburbField').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  public toggleCoterm(): void {
    if (!this.userFormGroup.get('userGroup.cotermToggle').value) return;
    this.userFormGroup.get('userGroup.cotermToggle').setValue(!this.userFormGroup.get('userGroup.cotermToggle').value);
  }

  public toggleCommitment(): void {
    if (!this.userFormGroup.get('userGroup.commmitmentToggle').value) return;
    this.userFormGroup.get('userGroup.commmitmentToggle').setValue(!this.userFormGroup.get('userGroup.commmitmentToggle').value);
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  isNotValidField(path: string, validation: any): void {
    if (path == "userGroup.emailField") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  startFilterPostcode(res: PostcodeList[]): void {
    this.filteredPostCode = res;
  }

  startFilterSub(res: PostcodeList[]): void {
    this.filteredSub = res;
  }
  onInputSub(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/AMP/AMPDetails/" + this.details?.customer?.customer_id);
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
  }
  omit_nonprintable_char(event: any) {
    event.target.value = this.commonService.omit_nonprintable_char(event.target.value);
    if (event.target.id == "addressLine1") {
      this.userFormGroup.get('userGroup.addressLine1Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine2") {
      this.userFormGroup.get('userGroup.addressLine2Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine3") {
      this.userFormGroup.get('userGroup.addressLine3Field').setValue(event.target.value);
    }
  }
  ngOnDestroy() {
    this.adobeService.extra3YCOption = null;
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
